import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {Overlay} from "../../../services/overlay/Overlay";
import {interval, Subject} from "rxjs";
import {throttle} from "rxjs/operators";
declare var Yiit;

@Component({
  selector: 'app-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayComponent implements OnInit {

  @Input() overlay:Overlay;

  public opacityAggregator:Subject<number> = new Subject();
  public Yiit = Yiit;

  constructor() { }

  ngOnInit() {
    // optimize updates
    this.opacityAggregator
      .pipe(throttle(e => interval(1000), { trailing: true }))
      .subscribe((opacity) => {
        this.overlay.setOpacity(opacity);
      });
  }

}
